// Copy for the shared site footer.
const en = {
  logoAlt: 'StratoData Logo',
  tagline: 'Your experienced on-demand data team',
  contactUs: 'Contact us',
  about: 'About',
  copyright: 'Copyright © Stratodata. All rights reserved',
  privacyPolicy: 'Privacy Policy',
};

const sk: typeof en = {
  logoAlt: 'Logo Stratodata',
  tagline: 'Váš skúsený dátový tím vždy, keď ho potrebujete',
  contactUs: 'Kontaktujte nás',
  about: 'O nás',
  copyright: 'Copyright © Stratodata. Všetky práva vyhradené',
  privacyPolicy: 'Ochrana osobných údajov',
};

export const footerCopy = { en, sk };
